import React from "react";
// import { useState } from "react";
// import { connect } from "react-redux";
// import { firestoreConnect } from "react-redux-firebase";
// import { compose } from "redux";

const ProjectDetails = (props) => {
  console.log(props);
  return (
    <div className="container section project-details">
      <div className="card z-depth-0">
        <div className="card-content grey-text text-darken-3">
          <span className="card-title">
            {props.location.state.project.title}
          </span>
          <p>{props.location.state.project.content}</p>
          <br />
          <p> Posted by {props.location.state.project.authorFirstName}</p>
          <p className="grey-text">jan29 2022, 11am</p>
        </div>
      </div>
    </div>
  );
};

// const mapToProps = (state, ownProps) => {
//   const id = ownProps.match.params.id;
//   const project = state.firestore.data.project;
//   const projects = project ? project[id] : null;

//   return {
//     projects: projects,
//   };
// };

// export default compose(
//   connect(mapToProps),
//   firestoreConnect([
//     {
//       collection: "project",
//     },
//   ])
// )(ProjectDetails);
export default ProjectDetails;
